import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TokenService } from '../../services/auth/token.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor (private router: Router, private tokenService: TokenService) { }

  canActivate (): boolean {
    const isLoggedIn = !!this.tokenService.getToken(); // Check if the user is logged in by checking if a token exists

    if (!isLoggedIn) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}